function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.66757 2.66675L13.3342 13.3334M11.0009 11.1707C10.0992 11.6564 9.07998 12 8.0009 12C5.64714 12 3.57847 10.3653 2.39218 9.18595C2.07904 8.87465 1.9225 8.71902 1.82284 8.41349C1.75177 8.1956 1.75175 7.80446 1.82284 7.58658C1.92253 7.28106 2.0794 7.12505 2.39316 6.81319C2.99108 6.21889 3.81298 5.50914 4.78244 4.95125M13.0009 9.75572C13.2229 9.56044 13.4263 9.36831 13.6088 9.18693L13.6107 9.1849C13.9231 8.87436 14.0798 8.71867 14.1792 8.41382C14.2503 8.19594 14.2502 7.80464 14.1791 7.58675C14.0795 7.28133 13.9227 7.12525 13.6098 6.81415C12.4235 5.6348 10.3547 4.00008 8.0009 4.00008C7.7759 4.00008 7.55351 4.01502 7.33424 4.04307M8.88285 9.00008C8.6478 9.20754 8.33905 9.33341 8.0009 9.33341C7.26452 9.33341 6.66757 8.73646 6.66757 8.00008C6.66757 7.64041 6.80998 7.31413 7.04149 7.0743",
  stroke: "#707274",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgBoldHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldHide);
export default __webpack_public_path__ + "static/media/bold_hide.cd940419.svg";
export { ForwardRef as ReactComponent };